import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { ConfigProvider } from 'antd'
import Cookie from 'js-cookie'
import zhCN from 'antd/es/locale/zh_CN'
import reducer from './reducers'
import RouterMap from './router/RouterMap'
import rootSaga from './saga'
import { authUser } from './services'
import { getUrlParams } from './utils'
import './index.less'
import 'antd/dist/antd.css'
import './assets/css/iconfont.css'

const sagaMiddleware = createSagaMiddleware()
const store = createStore(reducer, applyMiddleware(sagaMiddleware))
sagaMiddleware.run(rootSaga)
const renderReact = () => {
  ReactDOM.render(
    <ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <RouterMap />
      </Provider>
    </ConfigProvider>,
    document.getElementById('root') as HTMLElement
  )
}
// 如果跳转到注册或者协议页面，无需判断登录态
const noPerms = ['/pure/register','/pure/forgetPassword', '/pure/agreement', '/pure/mkt-agreement', '/pure/privacy', '/pure/invalid']
if (noPerms.includes(window.location.pathname)) {
  renderReact()
} else {
  const params: any = getUrlParams(window.location.href);
  const { token, id } = params || {};
  if(token && id){
    const expires = new Date();
    expires.setTime(expires.getTime() + (24 * 60 * 60 * 1000));

    Cookie.set('NAGATO_PROOF', token, {
      expires: 1,
      path: '/',
      domain: '.aiclk.com'
    })

    Cookie.set('userID', id, {
      expires: 1,
      path: '/',
      domain: '.aiclk.com'
    })

    setTimeout(() => {
      window.location.replace(window.location.origin);
    }, 100)  
  } else {
    authUser({}).then((res:any) => {
      Cookie.set('bm_user_id', res.id)
      Cookie.set('bm_company', res.business_name)
      renderReact()
    })
  }
}





// WEBPACK FOOTER //
// ./src/index.tsx